import { rpc_CrearInventarioInicial } from "../infrastructure/supabase/procesoInventarioInicial.repository.js";

export async function crearInventarioInicialUseCase(periodoId) {
  // Validación inicial
  if (!periodoId) {
    console.warn("[crearInventarioInicialUseCase] periodoId es requerido");
    return { success: false, error: "El periodoId es requerido" };
  }

  try {
    console.debug("[crearInventarioInicialUseCase] Llamando RPC con periodoId:", periodoId);

    const resultado = await rpc_CrearInventarioInicial(periodoId);

    if (!resultado || resultado.success === false) {
      console.error("[crearInventarioInicialUseCase] No se pudo crear inventario inicial:", {
        periodoId,
        error: resultado?.error,
      });
      return {
        success: false,
        error: resultado?.error || "No se pudo crear el inventario inicial",
      };
    }

    console.info("[crearInventarioInicialUseCase] Inventario inicial creado exitosamente:", periodoId);
    return resultado;

  } catch (error) {
    // Captura cualquier error inesperado
    console.error("[crearInventarioInicialUseCase] Error inesperado:", {
      periodoId,
      error: error?.message || error,
    });
    return {
      success: false,
      error: error?.message || "Error inesperado al crear inventario inicial",
    };
  }
}